import React, { PureComponent } from 'react'
import { string, func, shape } from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import DOMPurify from 'dompurify'

class I18nMessage extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    id: string.isRequired,
    params: shape({}),
    className: string,
  }

  static defaultProps = {
    params: {},
    className: '',
  }

  render() {
    const {
      i18n, id, params, className,
    } = this.props
    const rawHtml = decodeURIComponent(i18n(id, params))
    const safeHtml = DOMPurify.sanitize(rawHtml, {
      ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'ul', 'li', 'br', 'span'],
      ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
    })
    return (
      // eslint-disable-next-line react/no-danger
      <span dangerouslySetInnerHTML={{ __html: safeHtml }} className={className} />
    )
  }
}

export default withI18n(I18nMessage)
